import { createClient } from '@supabase/supabase-js'

// Project ID will be auto-injected during deployment
const SUPABASE_URL = 'https://ezzhhvvzemtgypmegmdd.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV6emhodnZ6ZW10Z3lwbWVnbWRkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzEyNTU4MjYsImV4cCI6MjA4NjgzMTgyNn0._BoYVZOk4mR8d6s4i__pyBuT-7YxGZpc_1zROwtcOeY'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})